import React, { Fragment, useEffect, useState } from "react";
import "./Subitems.css";
import {
  Dialog,
  DialogContent,
  Grid,
  Typography,
  Tooltip,
  IconButton,
  DialogTitle,
  DialogActions,
  Input,
  Button,
  CircularProgress,
} from "@mui/material";

import ListAltIcon from "@mui/icons-material/ListAlt";
import { API_URL, backend } from "../../../config";

const Subitems = (props) => {
  const { bulkState, data, locked, handleSubitemsChange } = props;

  const [openCatchWeightDialog, setOpenCatchWeightDialog] = useState(false);
  const [savingData, setSavingData] = useState(false);
  const [subItems, setSubItems] = useState([]);
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });

  const handleCloseCatchWeightDialog = () => setOpenCatchWeightDialog(false);

  const handleClickCatchWeightDialog = () => setOpenCatchWeightDialog(true);

  const handleChange = (e) => {
    const { name, value } = e.target;

    const [attrName, objIndex] = name.split("-");

    setSubItems((prevState) =>
      prevState.map((item, index) => {
        if (index !== +objIndex) return item;

        return {
          ...item,
          [attrName]: value,
          modified: true,
        };
      })
    );
  };

  const sendRequest = () => {
    setSavingData(true);

    let errorInf = { error: false, message: "" };

    const errorInfAssign = (item, error) => {
      const errorData = error.response.data;

      errorInf.error = true;
      let newMsg =
        typeof errorData === "object"
          ? errorData.hasOwnProperty("message")
            ? errorData.message
            : errorData.detail
          : error.message;

      if (newMsg === undefined) {
        const orderItemId = item.order_item;

        let newMsgConcat = "";

        const hasKeys = Object.keys(errorData);

        if (hasKeys && hasKeys.length) {
          newMsgConcat += `OrderItem ${orderItemId}:`;

          hasKeys.forEach((key) => {
            newMsgConcat += `${key}: ${hasKeys[key]}${
              hasKeys.length > 1 ? " | " : ""
            }`;
          });
        }

        newMsg = newMsgConcat;
      }

      if (newMsg !== "") {
        const errorMsg =
          errorInf.message +
          `${errorInf.message === "" ? "" : "<br />"}` +
          newMsg;

        errorInf.message = errorMsg;
      }

      setErrorInfo({ error: errorInf.error, message: errorInf.message });
    };

    Promise.all(
      subItems.map(async (item) => {
        let itemOverride = Object.assign(item);

        if (item.deleted) {
          return await backend
            .delete(`${API_URL}ordersubitems/${item.id}`)
            .then(() => {
              return item;
            })
            .catch((error) => {
              console.log(error);
              errorInfAssign(item, error);
            });
        } else if (item.modified && !item.new) {
          let siModified = {
            order_item: item.order_item,
            unit_type: item.unit_type,
          };

          if (["wl", "w"].includes(data.subitem_type)) {
            siModified.weight_lbs = item.weight_lbs;
          }

          if (["wl", "l"].includes(data.subitem_type)) {
            siModified.lot_code = item.lot_code || null;
          }

          return await backend
            .patch(`${API_URL}ordersubitems/${item.id}`, siModified)
            .then(({ data }) => {
              itemOverride = { ...itemOverride, ...data };
              return itemOverride;
            })
            .catch((error) => {
              console.log(error);
              errorInfAssign(item, error);
            });
        } else if (item.id === null && item.new) {
          let siNew = {
            order_item: item.order_item,
            unit_type: item.unit_type,
          };

          if (["wl", "w"].includes(data.subitem_type)) {
            siNew.weight_lbs = item.weight_lbs;
          }

          if (
            ["wl", "l"].includes(data.subitem_type) &&
            item.lot_code !== null &&
            item.lot_code !== ""
          ) {
            siNew.lot_code = item.lot_code;
          }

          return await backend
            .post(`${API_URL}ordersubitems/`, siNew)
            .then(({ data }) => {
              itemOverride = { ...itemOverride, ...data };
              return itemOverride;
            })
            .catch((error) => {
              console.log(error);
              errorInfAssign(item, error);
            });
        } else {
          return Promise.resolve(item);
        }
      })
    )
      .then((result) => {
        const resultMap = result.map((rItem, rIndex) =>
          rItem === undefined ? subItems[rIndex] : rItem
        );

        handleSubitemsChange(data.upc, resultMap);

        if (!errorInf.error) {
          setSavingData(false);
          handleCloseCatchWeightDialog();
        }
      })
      .catch((error) => {
        console.log(error);
        setErrorInfo({
          error: true,
          message: JSON.stringify(error.response.data),
        });
      });
  };

  useEffect(() => {
    const assignUpdateSubItems = () => {
      setSubItems(() => {
        let subItemsArray = [];
        let unitsCount = 0;
        let casesCount = 0;

        if (bulkState) {
          data.dupitems.forEach((dupItem, index) => {
            dupItem.subitems.forEach((item) => {
              subItemsArray.push({
                ...item,
                lot_codeOrig: item.lot_code,
                new: !item.hasOwnProperty("id"),
                modified: item.modified || false,
                deleted:
                  index + 1 >
                  (item.unit_type === "u"
                    ? data.unit_quantity
                    : data.case_quantity),
              });
            });
          });
        } else {
          subItemsArray = data.subitems.map((item, index) => {
            const mustDelete =
              item.unit_type === "u"
                ? unitsCount + 1 > data.unit_quantity
                : casesCount + 1 > data.case_quantity;

            const subItemObj = {
              ...item,
              lot_codeOrig: item.lot_code,
              new: !item.hasOwnProperty("id"),
              modified: item.modified || false,
              deleted: mustDelete,
            };

            if (item.unit_type === "u") {
              unitsCount += 1;
            } else {
              casesCount += 1;
            }

            return subItemObj;
          });
        }

        if (subItemsArray.length) {
          unitsCount = 0;
          casesCount = 0;

          subItemsArray.forEach((item) =>
            item.unit_type === "u" ? (unitsCount += 1) : (casesCount += 1)
          );

          // todo: not urgent but try to refactor/simplify next conditions
          if (unitsCount < data.unit_quantity) {
            const emptySubItem = {
              id: null,
              order_item: data.subitems[0].order_item,
              unit_type: "u",
              weight_lbs: 0,
              lot_codeOrig: null,
              new: true,
              modified: false,
              deleted: false,
            };

            const subItemsToAdd = data.unit_quantity - unitsCount;

            for (let index = 0; index < subItemsToAdd; index++) {
              subItemsArray = [...subItemsArray, emptySubItem];
            }
          }

          if (casesCount < data.case_quantity) {
            const emptySubItem = {
              id: null,
              order_item: data.subitems[0].order_item,
              unit_type: "c",
              weight_lbs: 0,
              lot_codeOrig: null,
              new: true,
              modified: false,
              deleted: false,
            };

            const subItemsToAdd = data.case_quantity - casesCount;

            for (let index = 0; index < subItemsToAdd; index++) {
              subItemsArray = [...subItemsArray, emptySubItem];
            }
          }
        }

        return subItemsArray;
      });
    };

    if (data || openCatchWeightDialog) {
      assignUpdateSubItems();
    }
  }, [data, openCatchWeightDialog, bulkState]);

  return (
    <>
      {!locked && subItems.length ? (
        <>
          <Tooltip title="Weight / Lot Information">
            <IconButton
              aria-label="weight_lot_information"
              onClick={handleClickCatchWeightDialog}
              disabled={data.out_of_stock}
            >
              <ListAltIcon />
            </IconButton>
          </Tooltip>
          <Dialog
            onClose={handleCloseCatchWeightDialog}
            open={openCatchWeightDialog}
          >
            <DialogTitle>Weight / Lot</DialogTitle>
            <DialogContent>
              {savingData ? (
                <Grid container spacing={1} textAlign="center">
                  <Grid item xs={12}>
                    <CircularProgress />
                  </Grid>
                  <Grid item xs={12}>
                    Saving weight / lot information
                  </Grid>
                  <Grid item xs={12}>
                    {errorInfo.error ? (
                      <>
                        <br />
                        <br />
                        {`There was an error while generating the invoice`}
                        <br />
                        <br />
                        <span
                          style={{
                            color: "red",
                            wordBreak: "break-word",
                            maxHeight: 160,
                            overflow: "hidden",
                            display: "inline-block",
                          }}
                        >
                          <b>Error:</b>
                          <br />
                          {errorInfo.message}
                        </span>
                        <div align="right">
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={() => handleCloseCatchWeightDialog()}
                          >
                            Continue
                          </Button>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </Grid>
                </Grid>
              ) : (
                <Grid container spacing={1}>
                  {bulkState ? (
                    <></>
                  ) : (
                    <>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1">
                          <strong>{`Order #${data.order}`}</strong>
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1">
                          <strong>Customer: </strong>
                          {data.order_customer
                            ? data.order_customer
                            : "Anonymous"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1">
                          <strong>Placed: </strong>
                          {data.hasOwnProperty("order_created")
                            ? new Date(data.order_created)
                                .toISOString()
                                .split("T")[0]
                            : "Unknown"}
                        </Typography>
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12}>
                    <Grid container spacing={1} alignItems="center">
                      <Grid item xs={12}></Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle1">
                          <strong>{`${data.name} Weight / Lot`}</strong>
                        </Typography>
                      </Grid>
                      {subItems.map((item, index) => (
                        <Fragment key={index}>
                          {index > 0 ? (
                            <></>
                          ) : (
                            <>
                              {bulkState ? (
                                <Grid item xs={2}>
                                  <b>Order</b>
                                </Grid>
                              ) : (
                                <></>
                              )}
                              <Grid item xs={2}>
                                <b>{bulkState ? "Unit" : "Unit Type"}</b>
                              </Grid>
                              <Grid item xs={2}>
                                <b>Price per lb</b>
                              </Grid>
                              {["wl", "w"].includes(data.subitem_type) ? (
                                <Grid item xs={true}>
                                  <b>Weight (lbs)</b>
                                </Grid>
                              ) : (
                                <></>
                              )}
                              {["wl", "l"].includes(data.subitem_type) ? (
                                <Grid item xs={true}>
                                  <b>Lot</b>
                                </Grid>
                              ) : (
                                <></>
                              )}
                            </>
                          )}
                          <Grid item xs={12}></Grid>
                          {!item.deleted ? (
                            <>
                              {bulkState ? (
                                <Grid item xs={2} textAlign="center">
                                  {item.order ? (
                                    <>
                                      {`#${item.order}`}
                                      <br />({item.order_customer})
                                    </>
                                  ) : (
                                    <>To be defined</>
                                  )}
                                </Grid>
                              ) : (
                                <></>
                              )}
                              <Grid item xs={2}>
                                {bulkState
                                  ? index + 1
                                  : item.unit_type === "u"
                                  ? "Unit"
                                  : "Case"}
                              </Grid>
                              <Grid item xs={2}>
                                {item.unit_type === "u"
                                  ? data.price_per_unit
                                  : data.price_per_case}
                              </Grid>
                              {["wl", "w"].includes(data.subitem_type) ? (
                                <Grid item xs={true}>
                                  <Input
                                    name={`weight_lbs-${index}`}
                                    value={item.weight_lbs}
                                    onChange={handleChange}
                                  />
                                </Grid>
                              ) : (
                                <></>
                              )}
                              {["wl", "l"].includes(data.subitem_type) ? (
                                <Grid item xs={true}>
                                  <Input
                                    name={`lot_code-${index}`}
                                    value={item.lot_code}
                                    onChange={handleChange}
                                  />
                                </Grid>
                              ) : (
                                <></>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </Fragment>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </DialogContent>
            <DialogActions>
              {errorInfo.error ? (
                <></>
              ) : (
                <>
                  <Button
                    color="error"
                    variant="contained"
                    onClick={handleCloseCatchWeightDialog}
                  >
                    Cancel
                  </Button>
                  <Button
                    color="success"
                    variant="contained"
                    onClick={sendRequest}
                  >
                    Save
                  </Button>
                </>
              )}
            </DialogActions>
          </Dialog>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default Subitems;
